export default __webpack_public_path__ + "static/media/back_rand2.ee5fff7b.jpg";